const tableCell = {
  styleOverrides: {
    head: ({ theme }) => ({
      ...theme.typography['p6'],
      color: theme.palette.primary.main,
      paddingTop: '.5rem',
      paddingBottom: '.5rem',
      backgroundColor: theme.palette.white.main,
    }),
  },
}

export default tableCell
